module.exports = __webpack_public_path__ + "img/blog-56.9eab48f2.jpg";